<template>
	<div class="col" gutter="20">
		<Title :title="id ? '編輯通知' : '新增通知'" />
		<router-link :to="{name: 'manageNotificationList'}">
			<el-button icon="el-icon-back" type="info" align-self="left"></el-button>
		</router-link>
		<el-form ref="ruleForm" :model="ruleForm" :rules="rules">
			<el-form-item label="選擇發送對象" prop="target">
				<el-select v-model="ruleForm.target">
					<el-option v-for="(target, i) in targetList" :value="target.value" :label="target.label" :key="i" />
				</el-select>
			</el-form-item>
			<el-form-item label="發信人別名" prop="nickname">
				<el-input v-model="ruleForm.nickname" placeholder="讓收信人此通知是來自於您，而不會誤以為是垃圾郵件" />
			</el-form-item>
			<el-form-item label="回覆 Email" prop="reply_email">
				<el-input v-model="ruleForm.reply_email" placeholder="讓收件人回覆到您指定的 Email" />
			</el-form-item>
			<el-form-item label="主旨" prop="subject">
				<el-input v-model="ruleForm.subject" />
			</el-form-item>
			<el-form-item label="內容" prop="content">
				<br />
				<tinymce v-model="ruleForm.content" />
			</el-form-item>
			<el-form-item>
				<h1>設定發送排程</h1>
				<hr />
			</el-form-item>
			<el-form-item prop="auto_send_time">
				<div class="col" gutter="10" align-x="left">
					<el-radio-group v-model="sendNow" @change="handleSelectTimeChange">
						<el-radio :label="true">立即發送</el-radio>
						<el-radio :label="false">指定時間</el-radio>
					</el-radio-group>
					<el-date-picker v-model="ruleForm.auto_send_time" :disabled="sendNow" type="datetime" value-format="timestamp"></el-date-picker>
				</div>
			</el-form-item>
			<el-form-item prop="test_email">
				<div class="col" align-x="left">
					<p class="color-text3">儲存發送前，您可先發一封測試信給自己，確認格式內容</p>
					<div class="row" align-y="center" gutter="20">
						<el-input v-model="ruleForm.test_email" placeholder="例：john@yahoo.com"></el-input>
						<el-button @click="handleTest()" type="primary">立即發送測試</el-button>
					</div>
				</div>
			</el-form-item>
			<el-form-item>
				<div class="row" align-x="right">
					<el-button @click="draft()">取消發送</el-button>
					<el-button @click="draft()">儲存為草稿</el-button>
					<el-button @click="send()" type="primary">儲存並發送</el-button>
				</div>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import { mapState, mapActions } from 'vuex';
import moment from "moment-timezone";
import Tinymce from "@/components/Tinymce/index.vue";
import _ from "lodash";

export default {
	components: { Title, Tinymce },
	data() {
		return {
			content: '',
			sendNow: false,
			is_test: false
		};
	},
	computed: {
		...mapState('notification', ['ruleForm', 'rules', 'targetList']),
		id() {
			return this.$route.params.id || '';
		}
	},
	filters: {},
	methods: {
		...mapActions('notification', ['getNotification', 'updateNotification', 'createNotification', 'resetForm', 'testNotification']),
		handleSelectTimeChange(val) {
			if (val) this.ruleForm.auto_send_time = Date.now();
		},
		draft() {
			this.is_test = false;
			_.assign(this.ruleForm, { status: 1 });
			_.unset(this.rules, 'test_email');
			this.submit();
		},
		send() {
			this.is_test = false;
			_.assign(this.ruleForm, { status: 2 });
			_.unset(this.rules, 'test_email');
			this.submit();
		},
		handleTest() {
			this.is_test = true;
			_.assign(this.rules, {
				test_email: [
					{ required: true, message: '測試信箱不能為空', trigger: 'blur' },
					{ type: 'email', message: '格式必須為email', trigger: 'blur' }
				]
			});
			this.submit();
		},
		submit() {
			this.$refs['ruleForm'].clearValidate();
			this.$refs['ruleForm'].validate(async valid => {
				if (valid) {
					try {
						if (this.is_test) {
							await this.testNotification(this.ruleForm);
							this.$message.success('成功送出，請至信箱檢查');
						} else {
							if (this.id) {
								await this.updateNotification(this.ruleForm);
							} else {
								await this.createNotification(this.ruleForm);
							}
							this.$message.success('更新成功');
							this.$router.back();
						}
					} catch (e) {
						this.$message.error(e);
					}
				} else {
					this.$message.error('請檢查必填項目');
				}
			});
		}
	},

	async created() {
		this.resetForm();
		if (this.id) await this.getNotification(this.id);
	},
};
</script>

<style lang="scss" scoped>
.el-form {
	max-width: 900px;
}

.score {
	position: fixed;
	right: -500px;
	top: 10px;
	transition: all 0.4s ease;

	.score-btn {
		width: 30px;
		height: 130px;
		text-align: center;
	}
}

.score-open {
	right: 0;
}

.picture-dialog {
	.description {
		padding: 15px 50px;
		font-size: 14px;
		font-weight: 500;
		line-height: 1.71;
		color: #000;
	}
}

.image-card {
	.thumb {
		width: 100%;
		padding-top: 70%;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}
	.caption {
		padding: 10px;
	}
}
</style>